import {h, Fragment} from "preact"
import { SerpElement, useCurrencyFormatting } from "@nosto/preact"
import { productImagePlaceholder, getHandle } from "../helpers"

export default function Product({ product }) {
    const { format } = useCurrencyFormatting()
    const tags = [
        product.onSale
            ? {
                  label: "Sale",
                  class: "ns-badge ns-badge-green-outline ns-d-inline-block ns-text-align-center"
              }
            : undefined
    ].filter(v => !!v)

    return (
        <SerpElement
            as="product-card"
            hit={product}
            ariaLabel={`Product ${product.name}`}
            class="product-card relative available gap-2" 
            reveal-on-scroll="true" 
            handle={getHandle(product.url)} 
            style="opacity: 1; transform: translateY(0px);"
        >
            
            <nosto-dynamic-card handle={getHandle(product.url)} template="card">
                <div class="product-card-skeleton"></div>
            </nosto-dynamic-card>
        </SerpElement>
    )
}
